__webpack_require__.p = "/login_reg_static_resources/";